import { IconElements, IconName } from '@clinic-monorepo/clinic-icon';
import React from 'react';

type Props = {
  name: IconName;
};

export const Icon = ({ name }: Props) => <>{IconElements[name]}</>;
